import { UnorderedListOutlined } from "@ant-design/icons";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import { Button, Form, Input, Modal, Select, message } from "antd";
import axios from "axios";
import clsx from "clsx";
import moment from "moment";
import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { defaultStatus } from "../../../../../helper/options";
import { serverUrl } from "../../../../../nestserver";
import plusicon from "../../../../../resources/plus.svg";

const ApplyLeave = () => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const queryClient = useQueryClient();
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const [applyLeavePopup, setApplyLeavePopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();

  //fetch student
  async function fetchStudent() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/students/by-parent/`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data.result;
  }
  const students = useQuery("students/by-parent", fetchStudent);

  async function getLeavesList() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/student-permission/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const leaveList = useQuery("/student-permission/", getLeavesList);
  const handleSelectChange = (studentId) => {
    const student =
      students?.data &&
      students?.data.length > 0 &&
      students?.data?.find((data) => data?._id === studentId);
    if (student) {
      setSelectedStudent(student?.class?.name);
    }
  };
  const onFinish = (values) => {
    const payload = {
      from: moment(values?.date[0]).format("YYYY-MM-DD"),
      to: moment(values?.date[1]).format("YYYY-MM-DD"),
      student: values?.name,
      type: values?.type,
      title: values?.title,
      description: values?.description,
    };
    axios({
      method: "post",
      url: serverUrl + "/student-permission/",
      data: payload,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((res) => {
        queryClient.invalidateQueries("/student-permission/");
        setApplyLeavePopup(false);
        message.success(res?.data?.result?.message);
        form.resetFields();
        setSelectedStudent(null);
      })
      .catch((error) => {
        message.error(error?.response?.data?.error?.errors);
      });
  };
  return (
    <div className="">
      <div className="pt-8">
        <div className="flex justify-between items-start pt-4 bg-white p-10 rounded-2xl">
          <div className="flex gap-20px flex-wrap	">
            {leaveList?.status === "success" &&
            leaveList?.data?.result &&
            leaveList?.data?.result?.data?.length > 0 ? (
              leaveList?.data?.result?.data?.map((list) => (
                <div>
                  <div
                    className="iskool-friends-card  flex flex-col space-x-3 cursor-pointer h-full p-20px capitalize"
                    key={list?._id}
                    style={{ width: "200px" }}
                  >
                    <span
                      className={clsx(
                        list?.status === defaultStatus?.approved
                          ? "bg-greenn"
                          : list?.status === defaultStatus?.pending
                            ? "bg-yellowe"
                            : list?.status === defaultStatus?.withdraw
                              ? "bg-gray"
                              : "bg-redd",
                        "p-1 rounded-lg text-center w-82px capitalize",
                      )}
                      onClick={() =>
                        navigate(
                          `/dashboard/parent/menu/student/leave/${list?._id}`,
                        )
                      }
                    >
                      {list?.status}
                    </span>
                    <div
                      className="text-center mt-14px"
                      onClick={() =>
                        navigate(
                          `/dashboard/parent/menu/student/leave/${list?._id}`,
                        )
                      }
                    >
                      <UnorderedListOutlined size={35} />
                      <div className="pt-2">
                        <div className="font-bold text-base line-clamp-2">
                          {list?.title}
                        </div>
                        <div className="font-bold h-8">
                          {moment(list?.createdAt).format("DD-MM-YYYY")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>No Applied leave Exists</div>
            )}
          </div>
          <div
            onClick={() => setApplyLeavePopup(true)}
            className="cursor-pointer p-28px add-module flex items-center justify-center mt-2"
          >
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center justify-center cursor-pointer">
                <img className="w-6 h-6" src={plusicon} alt="icon" />
              </div>
              <div className="text-white text-sm text-center ">
                <div>Apply Leave</div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          width={450}
          visible={applyLeavePopup}
          onOk={() => setApplyLeavePopup(false)}
          onCancel={() => {
            form.resetFields();
            setApplyLeavePopup(false);
            setSelectedStudent(null);
          }}
          footer={null}
          forceRender
        >
          <h3 className="text-lg font-bold pb-3">Apply Leave</h3>
          <div className="bg-white rounded-2xl ">
            <Form
              form={form}
              layout="vertical"
              name="basic"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="Name"
                name="name"
                className="w-full"
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  placeholder="Select name"
                  className="w-full bg-gray-300"
                  style={{
                    border: "6px",
                    backgroundColor: "#EBEBEB",
                  }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(value) => handleSelectChange(value)}
                >
                  {students &&
                    students?.data?.map((data) => {
                      return (
                        <Option key={data._id} value={data._id}>
                          {`${data?.first_name} ${data?.last_name}`}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item label="Class" className="w-full">
                <Input readonly value={selectedStudent} />
              </Form.Item>
              <Form.Item
                label="Date"
                name="date"
                className="w-full"
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <RangePicker
                  format={"DD/MM/YYYY"}
                  disabledDate={(d) =>
                    !d || d.isBefore(moment().startOf("day"))
                  }
                  className="w-full"
                />
              </Form.Item>
              <Form.Item
                label="Type"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Application type is required",
                  },
                ]}
              >
                <Select
                  getPopupContainer={(trigger) => trigger.parentNode}
                  placeholder="Select type"
                >
                  <Select.Option value="Sick Leave">Sick Leave</Select.Option>
                  <Select.Option value="Casual Leave">Casual Leave</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Title"
                name="title"
                className="w-full"
                rules={[
                  {
                    required: true,
                    message: "Title is required",
                  },
                  {
                    min: 1,
                    max: 15,
                    message: "Title must be between 1 and 15 characters",
                  },
                ]}
              >
                <Input maxLength={15} />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value && value.length <= 150) {
                        return Promise.resolve(); // Validation passed
                      }
                      return Promise.reject(
                        "Description must be at most 150 characters",
                      );
                    },
                  },
                ]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Reason"
                  className="w-full border focus:outline-none resize-none"
                  maxLength={150} // Limit the input to 150 characters visually
                />
              </Form.Item>
              <div className="text-center">
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="text-white"
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default ApplyLeave;
